module.exports = __webpack_public_path__ + "static/valueSurprising-a8fb25af3ec41575790f9b57d0fcb9fc.png";